import React from 'react'
import compose from 'recompose/compose'
import { connect as connectStaticText } from '../../StaticText/connect'
import Expandable from '../../Expandable/Expandable'
import StaticTextToHtml from '../../StaticTextToHtml/index'
import { NOTIFICATION_SETTINGS } from '../../../services/url/constants'
import NotificationRecommendedSettings from './NotificationRecommendedSettings'
import NotificationNewEpisodeSettings from './NotificationNewEpisodeSettings'

const NotificationSettings = (props) => {
  const { staticText } = props
  return (
    <Expandable
      id={NOTIFICATION_SETTINGS}
      variant="setting"
      header={staticText.getIn(['data', 'notificationsHeader'])}
      description={() => (
        <StaticTextToHtml staticText={staticText} staticTextKey={['data', 'notificationsBody']} />
      )}
    >
      <NotificationRecommendedSettings />
      <NotificationNewEpisodeSettings />
    </Expandable>
  )
}

export default compose(
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(NotificationSettings)
